/**
 * 'ios' | 'android' | null — pelo userAgent, não pela largura da tela: uma
 * janela estreita no desktop não tem app para baixar, e um iPad tem.
 */
export default function getMobilePlatform() {
    try {
        const ua = navigator.userAgent || '';

        if (/Android/i.test(ua)) return 'android';
        if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';

        // iPadOS 13+ se apresenta como Mac; o toque é o que denuncia.
        if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
    } catch {
        // Sem navigator (prerender), trata como desktop.
    }

    return null;
}
